import { render, staticRenderFns } from "./generic-loader.vue?vue&type=template&id=081062b5"
import script from "./generic-loader.vue?vue&type=script&lang=js"
export * from "./generic-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports